<h3>Contenu du site</h3>
<p class="astuce-section">
  Tous les paragraphes, citations et statistiques éditoriales du site public, modifiables
  en français / anglais / arabe. Ces textes sont différents des labels d'interface
  (boutons, menus...) qui restent fixes.
</p>

<form (ngSubmit)="enregistrer()">
  <div class="groupe" *ngFor="let groupe of groupes">
    <h4>{{ groupe.titre }}</h4>

    <div class="bloc" *ngFor="let item of groupe.cles">
      <label class="label-bloc">{{ item.label }}</label>
      <div class="trois-langues">
        <div>
          <span class="tag-langue">FR</span>
          <textarea [(ngModel)]="valeurs[item.cle].texteFr" [name]="item.cle + '-fr'" rows="2"></textarea>
        </div>
        <div>
          <span class="tag-langue">EN</span>
          <textarea [(ngModel)]="valeurs[item.cle].texteEn" [name]="item.cle + '-en'" rows="2"></textarea>
        </div>
        <div>
          <span class="tag-langue">AR</span>
          <textarea [(ngModel)]="valeurs[item.cle].texteAr" [name]="item.cle + '-ar'" rows="2" dir="rtl"></textarea>
        </div>
      </div>
    </div>
  </div>

  <p class="confirmation" *ngIf="messageConfirmation">{{ messageConfirmation }}</p>
  <button type="submit" [disabled]="enregistrementEnCours">
    {{ enregistrementEnCours ? 'Enregistrement...' : 'Enregistrer tout le contenu' }}
  </button>
</form>
